module.exports = __webpack_public_path__ + "img/kolor-16.006d4b31.png";